(function () {
  "use strict";

  CreateNewGroupCtrl.$inject = ['$scope', '$rootScope', 'resolveData', 'textLengthIndicatorState', 'groupsResource', '$location', 'compositeSearchData', 'authView', 'sortHelper', 'mtypes', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('CreateNewGroupCtrl', CreateNewGroupCtrl);

  function CreateNewGroupCtrl($scope, $rootScope, resolveData, textLengthIndicatorState, groupsResource, $location, compositeSearchData,
                              authView, sortHelper, mtypes, trainerPrivilege) {

    var userRole = trainerPrivilege.roles();

    if (!userRole.canEditGroups)
      $location.path('/TMS/ManageGroups');

    var groupMaxLength = 40;

    $scope.viewModel = {
      isValid: false,
      usersAndGroup: [],
      trainers: [],
      allGroupTrainers: [],
      restrictedTrainers: [],
      groupName: "",
      showTrainerPermissions: authView.showUserPermissionsManagement() ? true : false
    };

    var allUsers = _.map(_.filter(resolveData.users, function (u) {
      return u.status == mtypes.userStatus.active
    }), function (item) {
      return buildUser(item);
    }).sort(sortHelper.getStringPropertySorter({field: 'text', asc: true}));
    var allGroups = _.map(resolveData.groups, function (item) {
      return buildGroup(item);
    }).sort(sortHelper.getStringPropertySorter({field: 'text', asc: true}));
    var isBusy = false;

    function buildUser(item) {
      return {
        id: item.id,
        text: _.escape(item.lastName) + ', ' + _.escape(item.firstName),
        type: 'user'
      };
    }

    function buildGroup(item) {
      return {
        id: item.id,
        text: _.escape(item.name) + " (" + item.userCount + ")",
        type: 'group'
      };
    }

    function usersAndGroupsQuery(query) {
      query.callback({results: getAllUsersAndGroups(query.term)});
    }

    function trainersQuery(query) {
      query.callback({results: getAllTrainersToSelect(query.term)});
    }

    function showSpinner() {
      $rootScope.$broadcast('$showLoadingSpinner', true);
    }

    function hideSpinner() {
      $rootScope.$broadcast('$showLoadingSpinner', false);
    }

    function getAllUsersAndGroups(term) {
      var users = [];
      var groups = [];

      if (term && term.length !== 0) {
        var termLower = term.toLowerCase();

        users = _.filter(allUsers, function (item) {
          return item.text.toLowerCase().indexOf(termLower) >= 0;
        });

        groups = _.filter(allGroups, function (item) {
          return item.text.toLowerCase().indexOf(termLower) >= 0;
        });
      } else {
        users = allUsers;
        groups = allGroups;
      }

      var ids = _.pluck($scope.viewModel.usersAndGroup, 'id');

      var filteredUsers = _.filter(users, function (u) {
        return !_.contains(ids, u.id);
      });

      var result = [];

      if (filteredUsers.length > 0) {
        result.push({
          text: "Users",
          children: filteredUsers
        });
      }

      if (groups.length > 0) {
        result.push({
          text: "Groups",
          children: groups
        });
      }

      return result;
    }

    function getAllTrainersToSelect(term) {

      var results;

      if (term && term.length == 0) {
        var termLower = term.toLowerCase();

        results = _.filter($scope.viewModel.restrictedTrainers, function (item) {
          return item.name.toLowerCase().indexOf(termLower) >= 0;
        });
      } else {
        results = $scope.viewModel.restrictedTrainers;
      }

      var groupTrainerIds = _.pluck($scope.viewModel.trainers, 'id');

      return _.filter(results, function (item) {
        return !_.contains(groupTrainerIds, item.id);
      });
    }

    $scope.selectUsersAndGroupsOptions = {
      width: '100%',
      multiple: true,
      query: usersAndGroupsQuery,
      minimumInputLength: 0,
      maximumInputLength: 40,
      allowClear: true,
      dropdownCssClass: "select2-dropdown-size-hack select2-short-dropdown"
    };

    $scope.selectTrainersOptions = {
      width: '100%',
      multiple: true,
      query: trainersQuery,
      minimumInputLength: 0,
      maximumInputLength: 40,
      allowClear: true,
      dropdownCssClass: "select2-dropdown-size-hack select2-short-dropdown"
    };

    $scope.groupSectionNameCssClass = function () {
      return $scope.viewModel.showTrainerPermissions ? "span12" : "span6 offset3";
    };

    $scope.userListSectionCssClass = function () {
      return $scope.viewModel.showTrainerPermissions ? "span6" : "span6 offset3";
    };


    $scope.addUserOrGroup = function (item, cb) {
      if (item.type == 'user') {
        $scope.viewModel.usersAndGroup.push(item);
        if (cb) {
          cb(false);
        }
      } else {
        //showSpinner();
        groupsResource.getGroupUsers(item.id, function (res) {

          var newIds = _.pluck(res, 'id');
          var existingIds = _.pluck($scope.viewModel.usersAndGroup, 'id');
          var usersToAdd = _.difference(newIds, existingIds);
          var users = _.filter(res, function (u) {
            return _.contains(usersToAdd, u.id);
          });

          _.each(users, function (user) {
            $scope.viewModel.usersAndGroup.push(buildUser(user));
          });

          //hideSpinner();
          if (cb) {
            cb(false);
          }
        });
      }
    };

    $scope.addTrainer = function (item) {
      $scope.viewModel.trainers.push(item);
    };

    $scope.removeTrainer = function (item) {
      $scope.viewModel.trainers = _.reject($scope.viewModel.trainers, function (i) {
        return i.id == item.id;
      });
    };

    $scope.removeUserOrGroup = function (item) {
      $scope.viewModel.usersAndGroup = _.reject($scope.viewModel.usersAndGroup, function (i) {
        return i.id == item.id;
      });
    };

    $scope.groupNameIndicatorStyle = "";
    $scope.groupNameIndicatorText = "";
    $scope.groupNameStyle = "";

    $scope.validateGroupNameLength = function () {
      var text = $scope.viewModel.groupName;

      var state = {};

      if (text === undefined || !text) {
        state = {lengthValid: true, dataValid: true};
      } else {
        state = textLengthIndicatorState.getState(text, groupMaxLength);
      }


      $scope.groupNameIndicatorStyle = state.style;
      $scope.groupNameIndicatorText = state.text;
      $scope.groupNameStyle = state.dataValid ? "" : "redBorder";
      if (text && text.length > 0 && state.lengthValid && state.dataValid) {
        $scope.viewModel.isValid = true;
      } else {
        $scope.viewModel.isValid = false;
      }
    };

    $scope.createGroup = function () {
      if (!$scope.viewModel.isValid) {
        return;
      }
      isBusy = true;
      var users = _.filter($scope.viewModel.usersAndGroup, function (i) {
        return i.type == 'user';
      });

      var trainers = _.filter($scope.viewModel.trainers, function (t) {
        return t.groupRestriction == true;
      });

      var newGroup = {
        name: $scope.viewModel.groupName,
        userIds: _.pluck(users, 'id'),
        trainerIds: _.pluck(trainers, 'id'),
        addNumberSuffix: true
      };

      groupsResource.addGroups([newGroup], function (res) {
        isBusy = false;
        compositeSearchData.setSearchData('group', res.groups[0].id);
        $location.path("/TMS/ManageGroups");
      }, function (err) {
        isBusy = false;
        $scope.viewModel.isValid = false;
      });
    };

    $scope.canCreate = function () {
      return !isBusy && $scope.viewModel.isValid;
    };

    $scope.$on("$destroy", function (event) {
    });


    if ($scope.viewModel.showTrainerPermissions) {
      groupsResource.getGroupTrainers(function (result) {
        _.each(result.allGroupTrainers, function (trainer) {
          trainer.name = trainer.lastName + ', ' + trainer.firstName;
          trainer.groupRestriction = false;
        });
        _.each(result.allRestrictedTrainers, function (trainer) {
          trainer.name = trainer.lastName + ', ' + trainer.firstName;
          trainer.groupRestriction = true;
        });
        $scope.viewModel.allGroupTrainers = result.allGroupTrainers;
        $scope.viewModel.trainers = $scope.viewModel.allGroupTrainers;
        $scope.viewModel.restrictedTrainers = _.uniq(result.allRestrictedTrainers, false, function (trainer) {
          return trainer.id;
        });
      });
    }

  }

})();
